<template>
<div class="relative flex flex-col items-center h-full"
    @click.stop="opened = !opened">
    <span class="link text-2xl"
        :class="{ 'mb-4': opened }">{{ props.title }} &#9660;</span>
    <Transition name="mobile-dropdown">
        <div v-if="opened" class="dropdown-menu relative flex flex-col items-center gap-4 min-w-52 h-auto pt-2"
        >
            <router-link 
                v-for="([pageTitle, pageLink], index) in dropdownOptions" :key="pageLink" :to="pageLink"
                class="dropdown-item cursor-pointer w-auto text-center text-[#f0f7f2] py-1"
                :style="{ '--drop-index': index }"
                @click="closeMenu"
            >
                <span class="dropdown-text text-lg">{{ pageTitle }}</span>
            </router-link>
        </div>
    </Transition>
</div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue';
interface Props {
    title: string;
    options: Record<string,  string>;
}
const props = defineProps<Props>();
const emit = defineEmits(["close-menu"]);


const opened = ref(false);
const dropdownOptions = computed(() => Object.entries(props.options));

const closeMenu = (): void => {
    emit('close-menu');
    opened.value = false;
}
</script>

<style scoped>
.link {
    text-decoration: none;
    color: #f0f7f2;
    text-shadow: 0px 0px 4px #a8c3b4;
    display: flex;
    align-items: center;
    cursor: pointer;
}


.link:hover {
    color: #b0cfc2;
    text-shadow: 0px 0px 4px #6a998f;
    transform: scale(1.0375);
    transition: transform 0.5s ease;
}

.dropdown-menu {
  transition: opacity 0.3s ease;
}

.mobile-dropdown-enter-active,
.mobile-dropdown-leave-active {
    transform-origin: top center;
    transition: opacity 0.35s ease, transform 0.35s ease;
}

.mobile-dropdown-enter-from,
.mobile-dropdown-leave-to {
    opacity: 0;
    transform: translateY(-10px) scaleY(0.92);
}

.mobile-dropdown-enter-to,
.mobile-dropdown-leave-from {
    opacity: 1;
    transform: translateY(0) scaleY(1);
}

.mobile-dropdown-enter-active .dropdown-item,
.mobile-dropdown-leave-active .dropdown-item {
    transition: opacity 0.28s ease, transform 0.28s ease;
    transition-delay: calc(var(--drop-index) * 60ms);
}

.mobile-dropdown-enter-from .dropdown-item,
.mobile-dropdown-leave-to .dropdown-item {
    opacity: 0;
    transform: translateY(-12px);
}

.mobile-dropdown-enter-to .dropdown-item,
.mobile-dropdown-leave-from .dropdown-item {
    opacity: 1;
    transform: translateY(0);
}

.dropdown-item {
    text-shadow: 0px 0px 4px #a8c3b4;
}

.dropdown-text {
    display: inline-block;
    transition: transform 0.5s ease, color 0.5s ease, text-shadow 0.5s ease;
}

.dropdown-item:hover .dropdown-text {
    transform: scale(1.0375);
    color: #b0cfc2;
    text-shadow: 0px 0px 4px #6a998f;
}

.relative:hover .dropdown-menu {
    display: flex;
}
</style>